import { observable, action, computed } from "mobx";

export enum NavigationMode {
  Keyboard,
  Mouse
}

export class GlobalUIStore {
  public viewportElement?: HTMLElement;

  public tooltip = observable({
    uid: null,
    setUID: action((uid: string) => (this.tooltip.uid = uid)),
    unsetUID: action((uid: string) => {
      if (this.tooltip.uid === uid) {
        this.tooltip.uid = null;
      }
    })
  });

  @observable public isNavBarOpen: boolean = false;
  @action public setIsNavBarOpen(isNavBarOpen: boolean) {
    this.isNavBarOpen = isNavBarOpen;
  }

  @observable public navigationMode: NavigationMode;
  @action public setNavigationMode(navigationMode: NavigationMode) {
    this.navigationMode = navigationMode;
  }

  @observable public isModalOpen: boolean = false;
  @action public setModalOpen(isOpen: boolean) {
    this.isModalOpen = isOpen;
  }

  @observable public isOverlayOpen: boolean = false;
  @action public setOverlayOpen(isOpen: boolean) {
    this.isOverlayOpen = isOpen;
  }

  private openDialogsAndPopovers = observable.map<string, true>(); // just using this as a Set
  @action public setDialogOrPopoverOpen(uid: string) {
    this.openDialogsAndPopovers.set(uid, true);
  }
  @action public setDialogOrPopoverClosed(uid: string) {
    this.openDialogsAndPopovers.delete(uid);
  }
  @computed public get isDialogOrPopoverOpen() {
    return this.openDialogsAndPopovers.size > 0;
  }

  /**
   * This captures the last element that received focus that was not document.body. It should
   * only be used as a fallback for when document.activeElement cannot be used due to a focused
   * element being removed from the DOM.
   */
  @observable public fallbackFocusedElement: HTMLElement;
  @action public setFallbackFocusedElement(element: HTMLElement) {
    this.fallbackFocusedElement = element;
  }
}
export const globalUIStore = new GlobalUIStore();
